var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bonus-animation",class:_vm.bonusShow ? 'bonus-show': ''},[_vm._l((_vm.coinsArray),function(ca,i){return _c('RotateCoin',{key:i,attrs:{"coinx":ca.x,"coiny":ca.y,"coinScale":ca.scale}})}),_vm._v(" "),_vm._l((_vm.chipsArray),function(ca,i){return _c('RotateDinero',{key:'chip' + i,attrs:{"dinerox":ca.x,"dineroy":ca.y,"dineroScale":ca.scale}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fc36df6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/animations/BonusAnimation.vue
// module id = 376
// module chunks = 0